<div class="bg-white border rounded p-3 mb-3">
  <h6 class="mb-2">Person Search</h6>
  <div class="row g-2 align-items-end mb-2">
    <div class="col-auto">
      <label class="form-label">First Name</label>
      <input type="text" class="form-control" placeholder="First name" [(ngModel)]="firstName" name="searchFirst" />
    </div>
    <div class="col-auto">
      <label class="form-label">Last Name</label>
      <input type="text" class="form-control" placeholder="Last name" [(ngModel)]="lastName" name="searchLast" />
    </div>
    <div class="col-auto">
      <label class="form-label">EIN</label>
      <input type="text" class="form-control" placeholder="EIN" [(ngModel)]="ein" numericOnly name="searchEin" />
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-primary" (click)="onSearch()">Search</button>
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-secondary" (click)="onClear()">Clear</button>
    </div>
  </div>

  @if (searching) {
    <p class="text-muted mt-4 mb-0">Searching...</p>
  } @else if (!searching && searchPerformed && results.length === 0) {
    <p class="text-danger mt-4 mb-0">No matches were found.</p>
  }

  @if (results.length > 0) {
    <div style="max-height: 22rem; overflow-y: auto" class="mt-3">
      <table class="table table-sm mb-0">
        <thead>
          <tr>
            <th
              style="width: 10%; white-space: nowrap; position: sticky; top: 0; background: white; z-index: 1"
              scope="col"
            ></th>
            <th
              style="width: 10%; white-space: nowrap; position: sticky; top: 0; background: white; z-index: 1"
              scope="col"
            >
              EIN
            </th>
            <th style="position: sticky; top: 0; background: white; z-index: 1" scope="col">Name</th>
          </tr>
        </thead>
        <tbody>
          @for (person of results; track person.personId) {
            <tr class="align-middle">
              <td class="ps-4" style="white-space: nowrap">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [checked]="isSelected(person.personId)"
                  [disabled]="isSelected(person.personId)"
                  (change)="onSelectPerson(person)"
                  [attr.aria-label]="'Select ' + person.firstName + ' ' + person.lastName"
                />
              </td>
              <td style="white-space: nowrap">{{ person.ein }}</td>
              <td>{{ person.firstName }} {{ person.lastName }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
